export enum ProjectPackageTypeEnum {
	monitor = 'monitor',
	management = 'management',
	bundle = 'bundle',
}
